<template>
    <div class="stage stage--full-size" v-show="opened" data-stage=7>
        <div class="contents" v-show="opened">
            <div class="booking-summary booking-confirmation-summary">
                <div class="booking-summary__block">
                    <div class="booking-summary__text">
                        <strong>{{ header }}</strong>
                        <p>
                            {{ confirmationMsg }}
                        </p>
                    </div>

                    <hr>

                    <table>
                        <tr>
                            <td>Reference</td>
                            <td><strong>{{ confirmedBooking.reference }}</strong></td>
                        </tr>
                        <tr>
                            <td>Type</td>
                            <td>{{ confirmedBooking.booking.type.name }}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>{{ confirmedBooking.booking.first_name }} {{ confirmedBooking.booking.last_name }}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{{ confirmedBooking.booking.email }}</td>
                        </tr>
                        <tr>
                            <td>Guests</td>
                            <td>{{ confirmedBooking.pax }} people</td>
                        </tr>
                        <tr>
                            <td>Date</td>
                            <td>{{ DateService.friendlyDate(confirmedBooking.date) }}</td>
                        </tr>
                        <tr>
                            <td>Time</td>
                            <td>{{ confirmedBooking.booking.time }}</td>
                        </tr>
                        <tr v-if="confirmedBooking.booking.offer">
                            <td>Offer</td>
                            <td>{{ confirmedBooking.booking.offer.title }}</td>
                        </tr>
                        <tr v-if="confirmedBooking.booking.notes !== ''">
                            <td>Notes</td>
                            <td>{{ confirmedBooking.booking.notes }}</td>
                        </tr>
                        <tr v-if="confirmedBooking.hasCustomField">
                            <td>{{ confirmedBooking.customFieldLabel }}</td>
                            <td>{{ confirmedBooking.customFieldValue }}</td>
                        </tr>
                    </table>

                    <div v-if="shouldShowRewards" class="booking-summary-offers booking-summary-callout">
                        <strong class="callout-title">
                            <svg viewBox="0 0 45 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <polygon id="Star" fill="#D8D8D8" points="22.5 32.6649997 8.68704657 42.5118994 13.7835673 26.3321406 0.150171867 16.2381006 17.1129484 16.0853595 22.5 0 27.8870516 16.0853595 44.8498281 16.2381006 31.2164327 26.3321406 36.3129534 42.5118994"></polygon>
                                </g>
                            </svg>
                            <span>GOOD NEWS</span>
                        </strong>

                        <span>You have earned <strong>{{ confirmedBooking.pointsEarned }}</strong> (<span v-html="confirmedBooking.pointsEarnedValue"></span>) points by making this booking.</span>

                        <!-- <span v-if="!loginService.getUser()">
                            Make sure you log in below or sign up once you have booked to claim your reward points.
                        </span> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { BookingStatus } from '../models/Booking'
  import DateService from '../services/DateService'

  export default {
    name: 'confirmationStage',
    props: [
      'confirmedBooking',
      'opened'
    ],
    data () {
      return {
        shouldShowRewards: false,
        DateService
      }
    },
    methods: {

    },
    computed: {
      header: function () {
        let msg = 'Thank you for '

        switch (this.confirmedBooking.status) {
          case BookingStatus.received:
            msg += 'your enquiry!'
            return msg
          case BookingStatus.confirmed:
            msg += 'booking!'
            return msg
        }
      },

      confirmationMsg: function () {
        switch (this.confirmedBooking.status) {
          case BookingStatus.received:
            return 'We have successfully received your booking enquiry and we will get back to you as soon as possible. You will be contacted by our team shortly.'
          case BookingStatus.confirmed:
            return 'Thanks! Your booking at ' + this.confirmedBooking.venue.title + ' is confirmed. You will receive confirmation by email shortly.'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// confirmationStage.vue?4f655e70